<p [translate]="getVerificationDescription()"></p>

<form [formGroup]="form" (ngSubmit)="verify()" class="flex-col px-gap-10">
  <div>
    <ng-container *ngIf="!identityValue">
      <mat-form-field class="form-field" *ngIf="isMobileType; else email">
        <mat-label [translate]="getIdentityInputLabel()"></mat-label>
        <gb-intl-phone-input
          formControlName="identity"
          [auctionCountryCode]="(auction$ | async)?.country"
          name="identity"
          [allowNonNumeric]="true"
          [focusInput]="true"
        >
        </gb-intl-phone-input>
        <mat-icon matSuffix>person</mat-icon>
        <mat-error translate="AUTH.LOGIN.INPUT_LABEL_INVALID" *ngIf="!identityControl.valid"></mat-error>
      </mat-form-field>
      <ng-template #email>
        <mat-form-field class="form-field">
          <mat-label [translate]="getIdentityInputLabel()"></mat-label>
          <input matInput formControlName="identity" name="identity" #identityInput="matInput" required type="email" />
        </mat-form-field>
      </ng-template>
    </ng-container>
    <mat-form-field class="form-field">
      <mat-label translate="AUTH.VERIFY.CODE_LABEL"></mat-label>
      <input
        matInput
        #vcInput="matInput"
        formControlName="verification_code"
        name="verification_code"
        type="text"
        inputmode="numeric"
        numbersOnly
        required
      />
      <mat-error *ngIf="verificationCode.hasError('verify')">
        {{ verificationCode.getError('verify') }}
      </mat-error>
    </mat-form-field>
    <div class="flex-row flex-wrap flex-justify-end flex-align-center flex-fill">
      <button
        *ngIf="!hideSubmitButton"
        mat-raised-button
        color="primary"
        type="submit"
        class="verify-button"
        [disabled]="form.invalid"
        translate="AUTH.VERIFY.BUTTON"
      ></button>
    </div>
  </div>
  <div *ngIf="identityValue" class="flex-row flex-justify-center px-gap-5">
    <span translate="AUTH.VERIFY.RESEND_TEXT"> </span>
    <span translate="AUTH.VERIFY.RESEND_LINK" class="primary-link" (click)="resendVerification()"> </span>
  </div>
</form>

<div class="gb-verify-help">
  <h3 translate="AUTH.VERIFY.HELP_HEADER"></h3>
  <div *ngIf="shouldShowEmailVerificationHelp()" class="gb-verify-help-content">
    <p translate="AUTH.VERIFY.EMAIL_HELP_HEADER"></p>
    <ol>
      <li translate="AUTH.VERIFY.EMAIL_HELP_HEADER_SPAM"></li>
      <p translate="AUTH.VERIFY.EMAIL_HELP_CONTENT_SPAM"></p>
    </ol>
  </div>
  <div *ngIf="shouldShowPhoneVerificationHelp()" class="gb-verify-help-content">
    <p translate="AUTH.VERIFY.PHONE_HELP_HEADER"></p>
    <ol>
      <li translate="AUTH.VERIFY.PHONE_HELP_HEADER_RECEPTION"></li>
      <p translate="AUTH.VERIFY.PHONE_HELP_CONTENT_RECEPTION"></p>
      <strong>
        <li translate="AUTH.VERIFY.PHONE_HELP_HEADER_UNSUBSCRIBED"></li>
      </strong>
      <p
        [innerHTML]="
          'AUTH.VERIFY.PHONE_HELP_CONTENT_UNSUBSCRIBED'
            | translate: { sms_service_number: (auction$ | async)?.sms_service_number }
        "
      ></p>
    </ol>
  </div>
</div>
